module.exports = __webpack_public_path__ + "f4a5c00a.svg";